// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal__container[data-v-b0f51610]{max-width:400px}.modal__inner[data-v-b0f51610]{padding:0}", "",{"version":3,"sources":["webpack://./resources/assets/js/core/components/CreateAccountPopOut.vue"],"names":[],"mappings":"AAAA,mCAAA,eAAA,CAAA,+BAAA,SAAA","sourcesContent":[".modal__container{max-width:400px}.modal__inner{padding:0px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
